<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <BreadcrumbItem :title="$t('_home')" :to="{name: 'home'}" />
            <slot></slot>
        </ol>
    </nav>
</template>